export default "__VITE_ASSET__385b4439__"